import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import duration from 'dayjs/plugin/duration'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(duration)

export const getDiffBetweenDates = (date1: string, date2: string | null): { hours: number, milliseconds: number, minutes: number } => {
  const value1 = dayjs(date1)
  const value2 = dayjs(date2 || 0)

  const duration = dayjs.duration(value1.diff(value2))
  const milliseconds = duration.asMilliseconds()
  const hours = duration.asHours()
  const minutes = duration.asMinutes()

  return { milliseconds, hours, minutes }
}
